import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewWillEnter } from '@ionic/angular';
import { CaptionPipe } from 'src/app/pipes/caption.pipe';
import { DataService } from 'src/app/services/data.service';
import { ModalMakerService } from 'src/app/services/modal-maker.service';

@Component({
  selector: 'app-live-request',
  templateUrl: './live-request.component.html',
  styleUrls: ['./live-request.component.scss'],
})
export class LiveRequestComponent implements OnInit, ViewWillEnter {

  phoneNo: string = null;

  didInit = false;

  constructor(
    public dataServ: DataService,
    private actvrt: ActivatedRoute,
    private router: Router,
    public modalServ: ModalMakerService,
    private titleService: Title,
    private caption: CaptionPipe
  ) { }

  async ngOnInit() {
    if (!this.dataServ.menuSection) {
      const SECTIONID = Number(this.actvrt.snapshot.params.section);

      if (!this.dataServ.rData) {
        await this.dataServ.versionControl();
      }

      this.dataServ.getSection(SECTIONID);

      if (!this.dataServ.menuSection) {
        this.router.navigateByUrl('/home');
        return null;
      }
    }

    if (!this.dataServ.menuItem) {

      const ITEMID = Number(this.actvrt.snapshot.params.item);

      this.dataServ.getItem(ITEMID);

      if (!this.dataServ.menuSection) {
        this.router.navigateByUrl('/home');
        return null;
      }
    }

    if (this.dataServ.rData.call_for_requests) {
      switch (this.dataServ.menuSection.id) {
        case 117:
          this.phoneNo = this.dataServ.rData.sp_reception;
          break;
        case 126:
          this.phoneNo = this.dataServ.rData.sp_reception;
          break;
        case 115:
          this.phoneNo = this.dataServ.rData.sp_technical_service;
          break;
        case 114:
          this.phoneNo = this.dataServ.rData.house_keeping_phone;
          break;
        case 131:
          this.phoneNo = this.dataServ.rData.sp_customer_relation;
          break;
        default:
          this.phoneNo = this.dataServ.rData.sp_reception;
          break;
      }
    }
  }

  async ionViewWillEnter() {
    const SECTIONID = Number(this.actvrt.snapshot.params.section);
    if (!this.dataServ.menuSection || SECTIONID !== this.dataServ.menuSection.id) {
      await this.dataServ.getSection(SECTIONID);
    }

    if (!this.dataServ.menuItem || this.dataServ.menuItem.id !== Number(this.actvrt.snapshot.params.id)) {
      this.dataServ.menuItem = null;
      this.didInit = false;
      const ITEMID = Number(this.actvrt.snapshot.params.item);
      this.dataServ.getItem(ITEMID);
    }

    if(this.dataServ.menuItem && this.dataServ.menuItem.name) {
      this.titleService.setTitle(this.caption.transform(this.dataServ.menuItem.name, 'en'));
    }
    this.didInit = true;
  }

  call() {
    if (this.phoneNo) {
      window.open(`tel:${this.phoneNo}`, '_blank');
    }
  }
}
